// extracted by mini-css-extract-plugin
export default {"cvParsingConfigPage":"cv_parsing_conf_page-module___cvParsingConfigPage___a7e30da3","cvParsingConfigActions":"cv_parsing_conf_page-module___cvParsingConfigActions___e6b22343"};